module.exports = __webpack_public_path__ + "img/borderRadioWhite.6efdcb55.svg";